import { render } from "./ContactDisplay.vue?vue&type=template&id=d3a6c140"
import script from "./ContactDisplay.vue?vue&type=script&lang=js"
export * from "./ContactDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__